import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "./base-service";
import {Observable} from "rxjs/Observable";
import {AppConfig} from "../config/appconfig";
import { Storage } from '@ionic/storage';
import {IWorkRestModesReportParameters} from "../models/reports/i-work-rest-modes-report-parameters";
import {IDateRangeReportParameters} from "../models/reports/i-date-range-report-parameters";

/*
  Generated class for the TachoService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class TachoService  extends BaseService  {

  private readonly tachoReportsUrl: string = AppConfig.apiBaseUrl + "tacho/";

  constructor(
    public http: Http,
    protected storage: Storage
  ) {
    super(http, storage);
  }

  public GetViolationsOnly(d1: Date, d2: Date): Promise<any>{
    return new Promise<any>((resolve, reject) => {
      this._getViolationsOnly(d1, d2).subscribe(
        (data) => {
          return resolve(data);
        },
        (err) => {
          return reject(err);
        }
      );
    });
  }

  private _getViolationsOnly(d1: Date, d2: Date): Observable<any>{
    return this.http.get(
      this.tachoReportsUrl + "violations/" + d1.valueOf() + "/" + d2.valueOf(),
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }

  public GetViolationsVehicle(d1: Date, d2: Date): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._getViolationsVehicle(d1, d2).subscribe(
        (data) => {
          return resolve(data);
        },
        (err) => {
          return reject(err);
        }
      );
    });
  }

  private _getViolationsVehicle(d1: Date, d2: Date): Observable<any> {
    return this.http.get(
      this.tachoReportsUrl + "violationsvehicle/" + d1.valueOf() + "/" + d2.valueOf(),
      { headers: this.headers }
    )
      .map((res: Response) => {
        let body = res.json();
        var d = body || {};
        return d;
      });
    //.catch(this.handleError);
  }

  public GetViolations(d1: Date, d2: Date): Promise<any>{
    return new Promise<any>((resolve, reject) => {
      this.shortReport(d1, d2)
        .then(data => {

          return resolve(data);

          // if(Array.isArray(data)){
          //   let gen = this.getNonobservance(data, d1, d2);
          //   //gen = [].slice.call(gen);
          //   let genps = [];
          //   for(let g of gen){
          //     genps.push(g);
          //   }
          //   Promise.all(genps)
          //     .then(d => {
          //       return resolve(d);
          //     })
          //     .catch(e => {
          //       return reject(e);
          //     });
          // }
        })
        .catch(err => {
          return reject(err);
        });
    });
  }

  private *getNonobservance(data: any[], d1: Date, d2: Date){
    for(var item of data){
      if(item.report.ActivityItems){
        for(var activity of item.report.ActivityItems){
          if(activity.DisturbancesCount > 0){
            let d1 = new Date(activity.Date);
            let d2 = new Date(activity.Date);
            d2.setHours(d2.getHours() + 24);

            yield this.cardReport(item.cardId, d1, d2);
          }
        }
      }
    }
  }

  private shortReport(d1: Date, d2: Date): Promise<any[]>{
    return new Promise<any[]>((resolve, reject) => {
      this.GetShortCardReport(d1, d2).subscribe(
        (data) => {
          return resolve(data);
        },
        (err) => {
          return reject(err);
        }
      );
    });
  }

  private cardReport(cardid: number, d1: Date, d2: Date): Promise<any[]>{
    return new Promise<any[]>((resolve, reject) => {
      this.GetCardReport(cardid, d1, d2).subscribe(
        (data) => {
          return resolve(data);
        },
        (err) => {
          return reject(err);
        }
      );
    });
  }

  public GetShortCardReport(d1: Date, d2: Date): Observable<any[]>{
    return this.http.get(
      this.tachoReportsUrl + "cardshortreport/" + d1.valueOf() + "/" + d2.valueOf(),
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }

  public GetCardReport(cardid: number, d1: Date, d2: Date): Observable<any[]>{
    return this.http.get(
      this.tachoReportsUrl + "cardreport/" + cardid + "/" + d1.valueOf() + "/" + d2.valueOf(),
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }

  // AS: вывести суммарную инфу о режимах труда и отдыха всех водителей организации
  public getDriverModesSummary(p: IDateRangeReportParameters): Observable<any>{
    let url = this.tachoReportsUrl + "driverworkmodes/summary";

    return this.http.post(
      url,
      p,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
  }

  public getVehicleModesSummary(p: IDateRangeReportParameters): Observable<any> {
    let url = this.tachoReportsUrl + "vehicleworkmodes/summary";

    return this.http.post(
      url,
      p,
      { headers: this.headers }
    )
      .map((res: Response) => {
        let body = res.json();
        var d = body || {};
        return d;
      });
  }

}



// WEBPACK FOOTER //
// ./src/providers/tacho-service.ts